/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnsureFirstPartyMcpGrantRequest
 */
export interface EnsureFirstPartyMcpGrantRequest {
    /**
     * 
     * @type {string}
     * @memberof EnsureFirstPartyMcpGrantRequest
     */
    userId: string;
    /**
     * Stable OAuth client_id for the first-party Gondola surface.
     * @type {string}
     * @memberof EnsureFirstPartyMcpGrantRequest
     */
    clientId: string;
    /**
     * Human-readable connected-app name.
     * @type {string}
     * @memberof EnsureFirstPartyMcpGrantRequest
     */
    clientName: string;
    /**
     * Space-delimited MCP OAuth scopes to grant.
     * @type {string}
     * @memberof EnsureFirstPartyMcpGrantRequest
     */
    scope: string;
}

/**
 * Check if a given object implements the EnsureFirstPartyMcpGrantRequest interface.
 */
export function instanceOfEnsureFirstPartyMcpGrantRequest(value: object): value is EnsureFirstPartyMcpGrantRequest {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    return true;
}

export function EnsureFirstPartyMcpGrantRequestFromJSON(json: any): EnsureFirstPartyMcpGrantRequest {
    return EnsureFirstPartyMcpGrantRequestFromJSONTyped(json, false);
}

export function EnsureFirstPartyMcpGrantRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnsureFirstPartyMcpGrantRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'clientId': json['client_id'],
        'clientName': json['client_name'],
        'scope': json['scope'],
    };
}

export function EnsureFirstPartyMcpGrantRequestToJSON(json: any): EnsureFirstPartyMcpGrantRequest {
    return EnsureFirstPartyMcpGrantRequestToJSONTyped(json, false);
}

export function EnsureFirstPartyMcpGrantRequestToJSONTyped(value?: EnsureFirstPartyMcpGrantRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'client_id': value['clientId'],
        'client_name': value['clientName'],
        'scope': value['scope'],
    };
}

